import { Box } from '@mui/material';
import { LabelBadge } from '../../../../../shared/components/common/labelBadge';
import { currencyFormatterHelper } from '../../../../../helpers/currencyFormatterHelper';
import { CURRENCY } from '../../../../../config/appConfig';
import { InvestorDashboardLoanStatuses } from '../../../../../constants/investorDashboardStatus';

const statusColorMap = {
	PreCredit: { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' },
	Credit: { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' },
	PreCompliance: { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' },
	Compliance: { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' },
	PreFundraising: { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' },
	Fundraising: { bg: '#ffffff', text: '#063236', outlineClass: 'outline outline-blue-300' },
	FullyFilled: { bg: '#00D175', text: '#063236' },
	OnTime: { bg: '#ffffff', text: '#063236', outlineClass: 'outline outline-blue-300' },
	Late: { bg: '#EC9697', text: '#063236' },
	Default: { bg: '#EC9697', text: '#063236' },
	Rejected: { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' },
	Expired: { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' },
	FullyPaid: { bg: '#00D175', text: '#063236' },
};

const statusLabel = (raw) => InvestorDashboardLoanStatuses.find((status) => status.id === raw)?.name ?? raw;

export const InitializeInvestorLoansColumns = (t) => {
	return [
		{
			header: t('businessName'),
			accessorKey: 'businessName',
			size: 220,
		},
		{
			header: t('loanId'),
			accessorKey: 'loanId',
			size: 280,
			Cell: ({ cell }) => (cell?.getValue() || '').toString().toUpperCase(),
		},
		{
			header: t('loanAmount'),
			accessorKey: 'loanAmount',
			Cell: ({ cell }) => `${CURRENCY} ${currencyFormatterHelper(cell?.getValue())}`,
			size: 100,
		},
		{
			header: t('disbursedAmount'),
			accessorKey: 'disbursedAmount',
			Cell: ({ cell }) => `${CURRENCY} ${currencyFormatterHelper(cell?.getValue())}`,
			size: 120,
		},
		{
			header: t('repaid'),
			accessorKey: 'repaymentPercentage',
			Cell: ({ cell, row }) => {
				const pct = Math.min(100, Math.max(0, cell?.getValue() || 0));
				return (
					<Box className="flex flex-col gap-1 min-w-[100px]">
						<span className="text-xs font-bold">{pct}%</span>
						<Box className="w-full h-1.5 rounded-full bg-investor-mint/30 overflow-hidden">
							<Box
								className="h-full bg-investor-green rounded-full"
								sx={{ width: `${pct}%` }}
							/>
						</Box>
					</Box>
				);
			},
			size: 160,
		},
		{
			header: t('status'),
			accessorKey: 'status',
			Cell: ({ cell }) => {
				const raw = cell?.getValue();
				const colors = statusColorMap[raw] ?? { bg: 'rgba(150,150,150,0.15)', text: '#6e8192' };
				return (
					<LabelBadge
						label={statusLabel(raw)}
						bgColor={colors.bg}
						textColor={colors.text}
						classList={`!inline-flex !w-[140px] !rounded-full !px-2 !py-1 !text-[11px] !font-bold !normal-case !whitespace-nowrap ${colors.outlineClass ?? ''}`}
					/>
				);
			},
			size: 140,
		},
		{
			header: t('remaining'),
			accessorKey: 'remainingAmount',
			Cell: ({ row }) => {
				const remaining = (row.original.loanAmount || 0) - (row.original.repaidAmount || 0);
				return `${CURRENCY} ${currencyFormatterHelper(Math.max(0, remaining))}`;
			},
			size: 150,
		},
	];
};
